import { render, staticRenderFns } from "./ConsentAnswer.vue?vue&type=template&id=162e47e8&scoped=true&"
import script from "./ConsentAnswer.vue?vue&type=script&lang=js&"
export * from "./ConsentAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ConsentAnswer.vue?vue&type=style&index=0&id=162e47e8&scoped=true&lang=scss&"
import style1 from "./ConsentAnswer.vue?vue&type=style&index=1&id=162e47e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e47e8",
  null
  
)

export default component.exports